import { AxiosRequestConfig } from 'axios';
import api from 'api';

export const sendContactData = async (data: { name: string; userId?: number; phone: string }) => {
   return api.post('/v1/contactus/add', data);
};
